export const EMPTY_ARRAY_CHECK = /<[^>]*>/g
